import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { CommonModule } from '@angular/common';
import { MatMenu } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-site-incharge',
  templateUrl: './site-incharge.component.html',
  styleUrls: ['./site-incharge.component.scss'],
  standalone: true,
  imports: [CommonModule,MatMenu,MatButtonModule,MatMenuModule,MatIcon]
})
export class SiteInchargeComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL+'uploads/';
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public deleteUserUrl = BaseUrlConstantsService.DELETE_USERS;
  public managerListingUrl = BaseUrlConstantsService.MANAGER_LIST;
  public registerUserUrl = BaseUrlConstantsService.REGISTER_USERS;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public checked = false;
  public managerList: any = [];
  public selectValueArr = [];
  public breadcrumbsArray: any = [{
    page_ref: 'site-incharge',
    page_title: 'site incharge'
  }];
  public allManager: any;
  public showEmptyError = '';
  public today:Date;

  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog) {
      this.utcTime();
    }

  async goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  ngOnInit() {
    this.getAllManager();
  }





  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteUser(id, index);
      }
    });
  }


  deleteUser(user_id, index) {
    this.service.deleteInfo(this.deleteUserUrl + "/" + user_id).then(res => {
      if (JSON.parse(JSON.stringify(res)).message.includes("successfully deleted")) {
        this.service.showSuccess('Successfully deleted.');
        this.allManager.splice(index, 1);
        this.getAllManager();
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }

  getAllManager() {
    this.changeService.loader(true);
    this.service.getData(this.managerListingUrl+ 'SITE_INCHARGE').then(async res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.managerList = [];
        this.allManager = [];
        this.managerList = JSON.parse(JSON.stringify(res)).data.body;
        this.allManager = this.managerList;
        if (this.managerList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }


  async addClients() {
    this.router.navigate(['/create-site-incharge']);
  }

  editClient(id) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        adminUserId:id,
        pid: true,
        pageRef: 'admin-user'
      }
    };
    this.router.navigate(['/create-site-incharge'], navigationExtras);
  }


  searchData(ev) {
    const term = ev.toLowerCase();
    this.allManager = this.managerList.filter(
      result => result.full_name.toLowerCase().indexOf(term) >= 0 || result.country.toLowerCase().indexOf(term) >= 0);
    if (this.allManager.length === 0) {
      this.showEmptyError = 'No sites available.';
    } else {
      this.showEmptyError = '';
    }
  }
}
